import * as THREE from 'three';
import { Cookie } from './Cookie';
import type { GameConfig } from '../types/GameConfig';

type SpawnCallback = (cookie: Cookie) => void;

export class CookieSpawner {
  private timer: number = 0;

  constructor(
    private readonly config: Pick<GameConfig, 'cookieSpawnInterval' | 'cookieSpawnRadius' | 'cookieSpeed'>,
    private readonly onSpawn: SpawnCallback,
  ) {}

  update(delta: number): void {
    this.timer += delta;
    // Use while so that if delta > interval we don't skip spawns
    while (this.timer >= this.config.cookieSpawnInterval) {
      this.timer -= this.config.cookieSpawnInterval;
      this.spawn();
    }
  }

  private spawn(): void {
    const angle = Math.random() * Math.PI * 2;
    const r = this.config.cookieSpawnRadius;
    const pos = new THREE.Vector3(Math.cos(angle) * r, 0, Math.sin(angle) * r);
    this.onSpawn(new Cookie(pos, this.config.cookieSpeed));
  }
}
